import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from "primereact/checkbox";

const Store = () => {
    const [StoreId, setStoreId] = useState(null);
    const [storeName, setStoreName] = useState('');
    const [storeAddress, setStoreAddress] = useState('');
    const [storeStatus, setStoreStatus] = useState(1);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [StoreLogo, setStoreLogo] = useState(null);
    const [OldLogo, setOldLogo] = useState(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const { apiUrl, apiHeadersJson, apiHeadersFile } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const headersfile = apiHeadersFile;
    const toast = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        formData.append('store_name', storeName);
        formData.append('store_address', storeAddress);
        formData.append('store_status', storeStatus);
        formData.append('permissions', [permissions]);

        if (StoreLogo) {
            formData.append('store_logo', StoreLogo);
        }
        if (StoreId) {
            formData.append('store_id', StoreId);
        }
        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateStore`, formData, { headers: headersfile });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                getList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const getList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetStoreList`, { headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const handleResetForm = () => {
        setStoreId(null);
        setStoreName('');
        setStoreAddress('');
        setStoreStatus(1);
        setStoreLogo(null);
        setPermissions([]);
    };

    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setStoreLogo(file);
        }
    };

    const handleImageRemove = () => {
        setStoreLogo(null);
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Store?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteAddress(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const deleteAddress = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Masters/DeleteStore`, { params: { store_id: id }, headers });
            const { success, message } = response.data;

            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                getList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        getList();
    }, []);

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetStoreInfo`, { params: { store_id: id }, headers })
            const { success, data, message, storePermissions } = response.data;
            if (success) {
                setStoreId(data[0].store_id);
                setStoreAddress(data[0].store_address);
                setStoreStatus(data[0].store_status);
                setOldLogo(data[0].store_logo_url);
                setStoreName(data[0].store_name);
                setPermissions(storePermissions);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000, });
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const onPermissionToggle = (permission) => {
        setPermissions(prev => {
            if (prev.includes(permission)) {
                return prev.filter(p => p !== permission);
            } else {
                return [...prev, permission];
            }
        });
    };

    const actionBody = (data) => {
        return (
            <>
                <Button icon="pi pi-pencil" outlined onClick={() => GetInfo(data.store_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.store_id)} />
            </>
        );
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="row">
                <div className="col-md-4 mt-4">
                    <div className="card">
                        <h4 className="bg-dark text-white rounded-top p-3">Store</h4>
                        <form className='p-3' onSubmit={handleSubmit}>
                            <div className="my-2">
                                <label className="form-label">Store Name</label>
                                <InputText value={storeName} className="form-control" placeholder='Enter Name' onChange={(e) => setStoreName(e.target.value)} required />
                            </div>
                            <div className="my-2">
                                <label className="form-label">Store Address</label>
                                <textarea rows={4} value={storeAddress} className="form-control" placeholder='Enter Address' onChange={(e) => setStoreAddress(e.target.value)} required />
                            </div>
                            <div className="my-2">
                                <label className="form-label">Store Status</label><br />

                                <div className='d-flex justify-content-start align-itmes-center'>
                                    <label className="form-label">
                                        <span className='me-2'>Active</span>
                                        <Checkbox onChange={e => setStoreStatus(1)} checked={storeStatus === 1}></Checkbox>
                                    </label>
                                    <label className="form-label ms-3">
                                        <span className='me-2'>Inactive</span>
                                        <Checkbox onChange={e => setStoreStatus(0)} checked={storeStatus === 0}></Checkbox>
                                    </label>
                                </div>
                            </div>
                            <div className="my-2">
                                <label className="form-label">Store Permissions</label>

                                <div className='d-flex justify-content-start align-items-center'>
                                    <label className="form-label">
                                        <span className='me-2'>Discount</span>
                                        <Checkbox
                                            checked={permissions.includes('Discount')}
                                            onChange={e => onPermissionToggle('Discount')}
                                        />
                                    </label>
                                    <label className="form-label ms-3">
                                        <span className='me-2'>Wholesale/Retail Rates</span>
                                        <Checkbox
                                            checked={permissions.includes('AmountType')}
                                            onChange={e => onPermissionToggle('AmountType')}
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="my-2">
                                <label className="form-label">Store Logo <small className='text-primary'>(Height:305px - Width:816px)</small></label>
                                <div className="p-inputgroup">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="p-inputtext"
                                        onChange={handleImageSelect}
                                    />
                                    {StoreLogo && (
                                        <Button
                                            icon="pi pi-times"
                                            className="p-button-danger"
                                            onClick={handleImageRemove}
                                            style={{ marginLeft: '10px' }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex justify-content-between align-items-center">

                                    {StoreLogo ? (
                                        <div className="mt-2">
                                            <img
                                                src={URL.createObjectURL(StoreLogo)}
                                                alt="Preview"
                                                style={{ width: '100px', objectFit: 'cover' }}
                                            />
                                        </div>
                                    ) :
                                        <div className="mt-2 text-primary">
                                            Select Image For Preview
                                        </div>
                                    }
                                    {StoreLogo && StoreId && (
                                        <div className="mt-2">
                                            <i className="pi pi-arrow-right-arrow-left" style={{ fontSize: '2rem' }}></i>
                                        </div>
                                    )}
                                    {OldLogo && StoreId && (
                                        <div className="mt-2">
                                            <img
                                                src={OldLogo}
                                                alt="Preview"
                                                style={{ width: '100px', objectFit: 'cover' }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Button type="submit" label={loading ? "Loading..." : StoreId ? "Update" : "Submit"} className="btn btn-success mt-3" disabled={loading || !storeAddress || !storeName} />
                            {StoreId && <Button type="button" onClick={handleResetForm} label="Reset" className="btn btn-light mt-3 float-end" disabled={loading} />}
                        </form>
                    </div>
                </div>
                <div className="col-md-8 mt-4">
                    <div className="card">
                        <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                            <h4 className="text-white">Store List</h4>
                            <IconField iconPosition="left" style={{ width: '35%' }}>
                                <InputIcon className="pi pi-search"> </InputIcon>
                                <InputText
                                    className='w-100'
                                    placeholder='Search By Store Name...'
                                    onInput={(e) => {
                                        setFilters({
                                            global: { value: e.target.value, matchMode: FilterMatchMode.CONTAINS }
                                        });
                                    }}
                                />
                            </IconField>
                        </div>
                        <DataTable filters={filters} value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]} loading={dataTableLoading}>
                            <Column field='store_id' header='ID' sortable style={{ width: '10%' }} />
                            <Column
                                field="store_name"
                                header="Store Name"
                                body={(rowData) => (
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={rowData.store_logo_url}
                                            alt={rowData.store_name}
                                            style={{ width: 50, marginRight: '10px' }}
                                        />
                                        {rowData.store_name}
                                    </div>
                                )}
                            />
                            <Column field='store_address' header='Store Address' sortable />
                            <Column
                                header='Store Status'
                                body={(row) => {
                                    return row.store_status === 1 ? 'Active' : 'Inactive';
                                }}
                                sortable
                            />
                            <Column body={actionBody} header='Action' />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Store;
